module.exports = __webpack_public_path__ + "static/media/rabbitInside.43f08d69.png";